import { TranslocoPipe, provideTranslocoScope, translate } from '@jsverse/transloco';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CustomerContact } from 'customers';

type ReceiptsContactDialogData = {
  mode?: 'add' | 'edit';
  contact?: CustomerContact;
};

@Component({
  providers: [provideTranslocoScope('receipts')],
  selector: 'rev-receipts-contact-dialog-component',
  imports: [TranslocoPipe,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
  ],
  templateUrl: './receipts-contact-dialog-component.html',
  styleUrl: './receipts-contact-dialog-component.scss',
})
export class ReceiptsContactDialogComponent {
  private readonly data = inject<ReceiptsContactDialogData | null>(MAT_DIALOG_DATA, { optional: true });
  readonly dialogTitle = this.data?.mode === 'edit' ? translate<string>('receipts.ui.modificaContatto') : translate<string>('receipts.ui.aggiungiContatto');
  readonly addContactForm: FormGroup;

  constructor(
    private readonly dialogRef: MatDialogRef<ReceiptsContactDialogComponent>,
    private readonly formBuilder: FormBuilder,
  ) {
    this.addContactForm = this.formBuilder.group({
      nomeCognome: [this.data?.contact?.nominativo ?? '', Validators.required],
      telefono: [this.data?.contact?.telefono ?? '', Validators.maxLength(20)],
      cellulare: [this.data?.contact?.cellulare ?? '', Validators.maxLength(20)],
      fax: [this.data?.contact?.fax ?? '', Validators.maxLength(20)],
      email: [this.data?.contact?.email ?? ''],
      ruolo: [this.data?.contact?.ruolo ?? ''],
      note: [this.data?.contact?.note ?? ''],
      default: [{ value: this.data?.contact?.principale ?? false, disabled: true }],
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onReset(): void {
    this.addContactForm.reset({
      nomeCognome: '',
      telefono: '',
      cellulare: '',
      fax: '',
      email: '',
      ruolo: '',
      note: '',
      default: this.data?.contact?.principale ?? false,
    });
  }

  onApply(): void {
    if (this.addContactForm.invalid) {
      this.addContactForm.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.addContactForm.getRawValue());
  }
}
